import { render } from "./EventDetailsList.vue?vue&type=template&id=29526066"
import script from "./EventDetailsList.vue?vue&type=script&lang=js"
export * from "./EventDetailsList.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__